/**
 * 系统 Store
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { SystemSettings } from '../types/system';
import { http } from '../services/request';

interface SystemState {
  // 状态
  settings: SystemSettings | null;
  loading: boolean;

  // Actions
  fetchSettings: () => Promise<void>;
  updateSettings: (params: any) => Promise<void>;
  clearSettings: () => void;
}

export const useSystemStore = create<SystemState>()(
  devtools((set) => ({
    settings: null,
    loading: false,

    fetchSettings: async () => {
      set({ loading: true });
      try {
        // 模拟API调用
        // const response = await http.get<SystemSettings>('/system/settings');
        // set({ settings: response, loading: false });

        // 模拟数据
        const mockSettings: SystemSettings = {
          siteName: 'FunHua Admin',
          siteDescription: '一个现代化的管理后台系统',
          enableRegistration: true,
          enableEmailVerification: false,
          maintenanceMode: false,
        };
        set({ settings: mockSettings, loading: false });
      } catch (error) {
        console.error('获取系统设置失败:', error);
        set({ loading: false });
        throw error;
      }
    },

    updateSettings: async (params) => {
      set({ loading: true });
      try {
        // const response = await http.put('/system/settings', params);
        console.log('更新系统设置:', params);
        set({ settings: { ...params }, loading: false });
      } catch (error) {
        console.error('更新系统设置失败:', error);
        set({ loading: false });
        throw error;
      }
    },

    clearSettings: () => {
      set({ settings: null });
    },
  }))
);
